import React from "react";
import useResponsiveGridSize from "../../Hooks/useResponsiveGridSize";

const GRID_BASE = "cards-grid grid gap-4 my-4 min-w-0";

function CardsWrapper({ children, cols = 3, loading, className = "" }) {
	const { gridClassName } = useResponsiveGridSize({
		defaultCols: cols,
		considerSidebar: true,
	});

	const gridClass = `${GRID_BASE} ${gridClassName} ${className}`.trim();

	if (loading)
		return (
			<div className={gridClass}>
				{new Array(3).fill(0).map((_, i) => (
					<div key={i} role="status" className="w-full min-h-[7rem] rounded-xl animate-pulse bg-gray-100" />
				))}
			</div>
		);

	return <div className={gridClass}>{children}</div>;
}

export default CardsWrapper;
